import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { TranslateService } from '@ngx-translate/core';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { ConfigProvider } from '../../providers/config/config';
import { LoadingProvider } from '../../providers/loading/loading';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { Http } from '@angular/http';
import swal from 'sweetalert';
import { AlertProvider } from '../../providers/alert/alert';
import { HomePage } from '../home/home';

@Component({
  selector: 'page-about-us',
  templateUrl: 'about-us.html',
})
export class AboutUsPage {
  errorMessage = '';
  disableButton = false;
  contact = {self_surveyURL:'',customers_telephone:'',delivery_lastname:'',delivery_firstname:'',companyname:'',customer_id:0};
  constructor(
    public navCtrl: NavController,
    public shared: SharedDataProvider,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    public navParams: NavParams,
    public loading: LoadingProvider,
    public iab: InAppBrowser,
    translate: TranslateService,
    public http: Http,
    public alert: AlertProvider
  ) {
  }

sendLink()
{
  this.contact.self_surveyURL = this.shared.customerData.self_surveyURL;
  this.disableButton = true;
  this.contact.companyname = this.shared.customerData.companyname;
  this.contact.customer_id = this.shared.customerData.customers_id;

  console.log("Send SMS Self Survey Link:",this.contact);
  console.log("App Details:",this.shared.customerData);

  if( (this.shared.customerData.surveys_sent >= this.shared.customerData.surveys_limit) && this.shared.customerData.is_subscribed == '0' ){
    swal({title: "Sorry!",text: "Your have reached your account limit",icon: "error"}).then((value) => {
        //this.navCtrl.push(HomePage);
    });
  }
  else{
  var data = this.contact;
  this.http.post(this.config.url + 'sendSelfSurveyLink', data).map(res => res.json()).subscribe(data => {
      this.loading.hide();


    if (data.success == 1) {
      console.log("Success");
      swal({title: "Success!",text: "Survey Link is on its Way!",icon: "success"}).then((value) => {
          //this.navCtrl.push(HomePage);
          this.navCtrl.popToRoot()
      });

    }
    if (data.success == 0)
    {
      swal({title: "Sorry!",text: "Something is not right. Try again later",icon: "error"}).then((value) => {
          //this.navCtrl.push(HomePage);
      });

    }


  }, err => {

    swal({title: "Sorry!",text: "Something is not right. Try again later",icon: "error"}).then((value) => {
        //this.navCtrl.push(HomePage);
    });

this.disableButton = false;

  });

}

}
  openCart() {
    this.navCtrl.push(CartPage);
}
openSearch() {
    this.navCtrl.push(SearchPage);
}
ionViewWillEnter() {

}
}



// WEBPACK FOOTER //
// ./src/pages/about-us/about-us.ts